// extracted by mini-css-extract-plugin
export default {"container":"_20GWHdaaJAOYCFaGCCYv3O","vignette":"ouoFz52z0BPzNOakb-gwR"};